import React, { Component }        from 'react'
import StyleSheet                  from 'styles'
import {NumberDisplay} from 'components/numbers'
import {FormattedMessage} from 'react-intl'

export class Progress extends Component {
  get total() {
    return Number(this.props.total)
  }

  get claimed() {
    return Number(this.props.claimed)
  }

  get unclaimed() {
    return this.props.total - this.props.claimed
  }

  get progressPercent() {
    return (this.claimed / this.total * 100)
  }

  get unclaimedLabel() {
    return <FormattedMessage id={`allocation.section.amount.unclaimed_label.${this.claimed > 0 ? 'some_claimed' : 'none_claimed'}`} />
  }

  get ticker() {
    return this.props.ticker
  }

  get showKey() {
    return this.props.showKey
  }

  render = () =>
    <div className={this.props.className}>
      <div className={[styles.progress, this.props.progressClassName].join(' ')}>
        <span style={{width: `${this.progressPercent}%`}} />
      </div>

      {this.showKey &&
        <dl className={styles.keys}>
          <dt><span className={[styles.key, 'claimed'].join(' ')}/>
            <FormattedMessage id="allocation.section.amount.claimed_label" />
          </dt>
          <dd><NumberDisplay suffix={this.ticker}>{this.claimed.toFixed(2)}</NumberDisplay></dd>

          <dt><span className={[styles.key, 'remaining'].join(' ')}/>{this.unclaimedLabel}</dt>
          <dd><NumberDisplay suffix={this.ticker}>{this.unclaimed.toFixed(2)}</NumberDisplay></dd>
        </dl>
      }
    </div>
}

export const styles = StyleSheet({
  progress: {
    height: 15,
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#ccc',
    '& span': {
      display: 'inline-block',
      height: '100%',
      backgroundColor: '#586c7b',
    },
  },
  keys: {
    '& dt, dd': {
      position: 'relative',
      paddingLeft: 30,
      boxSizing: 'border-box',
    },
  },
  key: {
    width: 18,
    height: 18,
    display: 'block',
    position: 'absolute',
    top: 8,
    left: 0,
    '&.claimed': {
      backgroundColor: '#586c7b',
    },
    '&.remaining': {
      backgroundColor: '#ccc',
    }
  },
})